import { useMutation, useQueryClient } from '@tanstack/react-query';

import { usersKey } from '@pages/Users/services/useUsersInfiniteQuery';

import { apiClient } from '@services/apiClient';

const userCreateFn = (data) => apiClient.post(`${APP_SSO_URL}api/user/create`, data);

export const useUserCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: userCreateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [usersKey()[0]] });
    },
  });
};
